import { useFirstRenderContext } from '../ssr/FirstRenderProvider.js'

export type IconEmojiSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl'

type IconEmojiProps = {
  text: string
  size?: IconEmojiSize
  onClick?: (event) => void
}

export const IconEmoji = ({ text, size, ...rest }: IconEmojiProps) => {
  let shortCode = text
  if (!text.startsWith(':')) {
    shortCode = `:${text}:`
  }

  const emojiSize = {
    xs: 18,
    sm: 20,
    md: 22,
    lg: 32,
    xl: 64,
    '2xl': 96,
  }

  let sizeString = '1em'
  if (size && emojiSize[size]) {
    sizeString = `${emojiSize[size]}px`
  }

  /**
   * @tag Vite migration
   * em-emoji produces hydration error
   * As a workaround, it is initialized client-side only
   */
  const { isFirstRender } = useFirstRenderContext()

  if (isFirstRender) {
    return (
      <div
        className="bg-skeleton rounded-full"
        style={{ width: sizeString, height: sizeString }}
      />
    )
  }

  return <em-emoji shortcodes={shortCode} size={sizeString} {...rest} />
}
